import 'react-phone-number-input/style.css';
import ReactPhoneInput from 'react-phone-number-input';
import { forwardRef } from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: '#fff',
  },
}));

const CustomInput = forwardRef((props, ref) => {
  const classes = useStyles();

  return (
    <TextField
      {...props}
      InputProps={{
        className: classes.input,
        ...props.inputProps,
      }}
      inputRef={ref}
      fullWidth
      size="small"
      label="LADA"
      variant="outlined"
      name="phone"
    />
  );
});

export const PhoneCodeSelect = forwardRef(({ value, onChange, ...props }, ref) => {
  return (
    <ReactPhoneInput
      ref={ref}
      international
      defaultCountry="MX"
      value={value}
      inputComponent={CustomInput}
      onChange={onChange}
      {...props}
    />
  );
});
